var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11px",
    height: "10px",
    viewBox: "0 0 11 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Order Information - Products Unselected Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "4.383868 6.960633 9.32710194 0 11 1.10889774 4.68580437 10 0 5.53865822 1.424051 4.14259916"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Order-Information---Products-Unselected-Copy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u269B\\uFE0F-Atom-/-Indicator-/-Requirements-Good-Copy-5"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Check",
    fill: "#13AA41",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDD35-Color-/-Green-/-3-Dark",
    mask: "url(#mask-2)",
    fill: "#13AA41"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5.000000, -6.000000)",
    id: "Dark-Green"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 21,
    height: 20
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/Check_icon.8efbb9e7e33591233ced8d10078532e2.svg";
export { ForwardRef as ReactComponent };